import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30d12a68")

_pushScopeId("data-v-30d12a68")
const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("申报")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("转发")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下发卫生室")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = {
  key: 0,
  style: {"color":"#ff0000","margin":"10px"}
}
const _hoisted_10 = { class: "sub-table" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("点击上传")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("上传整改资料")
const _hoisted_13 = {
  key: 1,
  style: {"text-align":"center","margin-top":"10px"}
}
const _hoisted_14 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_15 = { style: {"width":"40%"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_17 = { style: {"width":"50%","height":"600px","overflow":"auto"} }
const _hoisted_18 = { style: {"text-align":"center","margin-top":"10px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vxe_table_column = _resolveComponent("vxe-table-column")
  const _component_vxe_button = _resolveComponent("vxe-button")
  const _component_vxe_table = _resolveComponent("vxe-table")
  const _component_vxe_pager = _resolveComponent("vxe-pager")
  const _component_vxe_checkbox = _resolveComponent("vxe-checkbox")
  const _component_vxe_checkbox_group = _resolveComponent("vxe-checkbox-group")
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")
  const _component_vxe_form = _resolveComponent("vxe-form")
  const _component_vxe_modal = _resolveComponent("vxe-modal")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_vxe_radio_button = _resolveComponent("vxe-radio-button")
  const _component_vxe_radio_group = _resolveComponent("vxe-radio-group")
  const _component_vxe_textarea = _resolveComponent("vxe-textarea")
  const _component_vxe_input = _resolveComponent("vxe-input")
  const _component_vxe_toolbar = _resolveComponent("vxe-toolbar")
  const _component_vxe_column = _resolveComponent("vxe-column")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_vxe_table, {
      data: _ctx.table.tableData,
      loading: _ctx.table.loading,
      "empty-text": "没有更多数据了！"
    }, {
      default: _withId(() => [
        _createVNode(_component_vxe_table_column, {
          type: "seq",
          width: "60"
        }),
        _createVNode(_component_vxe_table_column, {
          field: "task.taskName",
          title: "任务名称"
        }),
        _createVNode(_component_vxe_table_column, {
          width: "200",
          field: "task.startTime",
          title: "开始/截止时间"
        }, {
          default: _withId(({ row }) => [
            _createVNode("span", null, _toDisplayString(row.task ? row.task.startTime:''), 1),
            _hoisted_2,
            _createVNode("span", null, _toDisplayString(row.task ? row.task.endTime:''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_table_column, {
          field: "state",
          title: "状态",
          width: "80",
          formatter: _ctx.formatState
        }, null, 8, ["formatter"]),
        _createVNode(_component_vxe_table_column, {
          field: "task.remark",
          title: "备注",
          width: "200"
        }),
        (_ctx.canSubmit)
          ? (_openBlock(), _createBlock(_component_vxe_table_column, {
              key: 0,
              field: "subUserList",
              title: "转发科室",
              width: "200",
              formatter: _ctx.formatSubUserList
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (_ctx.userCompType === '0604'&& _ctx.canSubmit)
          ? (_openBlock(), _createBlock(_component_vxe_table_column, {
              key: 1,
              field: "downCount",
              title: "下发卫生室(次)",
              width: "120"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_vxe_table_column, {
          title: "操作",
          width: "260"
        }, {
          default: _withId(({row}) => [
            (row.state !== 2 && row.task.sameYear)
              ? (_openBlock(), _createBlock(_component_vxe_button, {
                  key: 0,
                  type: "text",
                  icon: "vxe-icon--edit-outline",
                  onClick: ($event: any) => (_ctx.editEvent(row))
                }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_vxe_button, {
              type: "text",
              icon: "vxe-icon--search",
              onClick: ($event: any) => (_ctx.viewEvent(row))
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.state !== 2 && row.task && _ctx.canSubmit && !row.task.hasOutTime)
              ? (_openBlock(), _createBlock(_component_vxe_button, {
                  key: 1,
                  type: "text",
                  icon: "vxe-icon--zoomout",
                  onClick: ($event: any) => (_ctx.forwardEvent(row))
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            ((_ctx.userCompType === '0603'|| _ctx.userCompType === '0604')
                    && row.state !== 2 && _ctx.canSubmit && row.task && ! row.task.hasOutTime)
              ? (_openBlock(), _createBlock(_component_vxe_button, {
                  key: 2,
                  type: "text",
                  icon: "vxe-icon--zoomout",
                  onClick: ($event: any) => (_ctx.downEvent(row))
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "loading"]),
    _createVNode(_component_vxe_pager, {
      background: "",
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[1] || (_cache[1] = ($event: any) => (_ctx.page.currentPage = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_ctx.page.pageSize = $event)),
      onPageChange: _ctx.pageChange,
      total: _ctx.page.totalResult,
      layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']
    }, null, 8, ["current-page", "page-size", "onPageChange", "total"]),
    _createVNode(_component_vxe_modal, {
      modelValue: _ctx.forwardData.editing,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.forwardData.editing = $event)),
      title: "请选择要转发的科室用户",
      width: "600",
      "min-height": "200",
      "show-zoom": ""
    }, {
      default: _withId(() => [
        _createVNode(_component_vxe_form, {
          "title-align": "right",
          "title-width": "120"
        }, {
          default: _withId(() => [
            _createVNode(_component_vxe_form_item, {
              title: "科室用户：",
              span: "24"
            }, {
              default: _withId(() => [
                _createVNode(_component_vxe_checkbox_group, {
                  modelValue: _ctx.forwardData.subUserSelect,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.forwardData.subUserSelect = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.forwardData.subUserData, (user) => {
                      return (_openBlock(), _createBlock(_component_vxe_checkbox, {
                        label: user.id,
                        content: user.deptName
                      }, null, 8, ["label", "content"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_form_item, {
              align: "center",
              span: "24"
            }, {
              default: _withId(() => [
                _createVNode(_component_vxe_button, {
                  status: "primary",
                  onClick: _ctx.submitForward
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_vxe_button, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.forwardData.editing = false))
                }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_vxe_modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal = $event)),
      id: "report-modal",
      title: "任务申报",
      width: "1200",
      "min-width": "600",
      "min-height": "600",
      fullscreen: _ctx.fullScreen,
      "lock-scroll": "true",
      "show-zoom": "true",
      resize: "",
      "destroy-on-close": "true"
    }, {
      default: _withId(() => [
        _createVNode(_component_vxe_modal, {
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogVisible = $event)),
          title: "申报资料",
          position: "top:60px;",
          draggable: true,
          type: "modal",
          duration: "-1",
          width: "600",
          height: "600",
          style: {"overflow":"auto"}
        }, {
          default: _withId(() => [
            (_ctx.dialogImageUrl)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.dialogImageUrl,
                  alt: "",
                  style: {"width":"100%"}
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("video", {
                  key: 1,
                  src: _ctx.dialogVideoUrl,
                  controls: "controls",
                  autoplay: "",
                  style: {"width":"100%"}
                }, " 您的浏览器不支持视频播放。 ", 8, ["src"]))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.editConfig.updateRemark)
          ? (_openBlock(), _createBlock("div", _hoisted_9, "整改意见：" + _toDisplayString(_ctx.editConfig.updateRemark), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_vxe_table, {
            onCellClick: _ctx.cellClick,
            ref: "xTable1",
            border: "",
            resizable: "",
            "keep-source": "",
            "row-id": "id",
            data: _ctx.editConfig.tableData,
            "auto-resize": true,
            "scroll-y": {enabled:true},
            "row-config": {height:100},
            "empty-text": "没有更多数据了！"
          }, {
            default: _withId(() => [
              _createVNode(_component_vxe_table_column, {
                type: "seq",
                width: "60"
              }),
              _createVNode(_component_vxe_table_column, {
                field: "parentId",
                title: "检查项",
                width: "160"
              }, {
                default: _withId(({ row }) => [
                  _createTextVNode(_toDisplayString(row.parentLabel), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_table_column, {
                field: "itemLabel",
                title: "检查要点"
              }, {
                default: _withId(({ row }) => [
                  _createTextVNode(_toDisplayString(row.itemLabel), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_table_column, {
                field: "attachmentList",
                title: "上传佐证资料",
                width: "300"
              }, {
                default: _withId(({ row }) => [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: "/api/onlineMedical/medicalComp/upLoadAtt",
                    headers: {rowId:row.id},
                    "list-type": "text",
                    name: "files",
                    disabled: !_ctx.editConfig.editable,
                    "show-file-list": true,
                    "file-list": row.attachmentList,
                    limit: 10,
                    accept: "image/*, video/mp4,\tapplication/msword,\tapplication/pdf,\r\n                                        application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    multiple: "",
                    "before-upload": _ctx.beforeAvatarUpload,
                    "on-preview": _ctx.handlePictureCardPreview,
                    "on-remove": _ctx.onRemove,
                    "on-success": _ctx.onSuccess
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary"
                      }, {
                        default: _withId(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["headers", "disabled", "file-list", "before-upload", "on-preview", "on-remove", "on-success"])
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_table_column, {
                field: "reportResult",
                width: "250",
                title: "结果"
              }, {
                default: _withId(({ row }) => [
                  _createVNode(_component_vxe_radio_group, {
                    modelValue: row.reportResult,
                    "onUpdate:modelValue": ($event: any) => (row.reportResult = $event),
                    disabled: !_ctx.editConfig.editable
                  }, {
                    default: _withId(() => [
                      (row.canAbsences === 1)
                        ? (_openBlock(), _createBlock(_component_vxe_radio_button, {
                            key: 0,
                            label: "1",
                            content: "合理缺项"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_vxe_radio_button, {
                        label: "2",
                        content: "不合格"
                      }),
                      _createVNode(_component_vxe_radio_button, {
                        label: "3",
                        content: "合格"
                      })
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_table_column, {
                field: "reportRemark",
                width: "250",
                title: "整改情况"
              }, {
                default: _withId(({ row }) => [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: "/api/onlineMedical/medicalComp/upLoadAtt",
                    headers: {rowId:row.id},
                    "list-type": "text",
                    name: "files",
                    disabled: !_ctx.editConfig.editable,
                    "show-file-list": true,
                    "file-list": row.updateAttachmentList,
                    limit: 10,
                    accept: "image/*, video/mp4,\tapplication/msword,\tapplication/pdf,\r\n                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    multiple: "",
                    "before-upload": _ctx.beforeAvatarUpload,
                    "on-preview": _ctx.handlePictureCardPreview,
                    "on-remove": _ctx.onUpdateFileRemove,
                    "on-success": _ctx.onUpdateFileSuccess
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary"
                      }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["headers", "disabled", "file-list", "before-upload", "on-preview", "on-remove", "on-success"]),
                  _createVNode(_component_vxe_textarea, {
                    modelValue: row.reportRemark,
                    "onUpdate:modelValue": ($event: any) => (row.reportRemark = $event),
                    placeholder: "整改情况说明",
                    disabled: !_ctx.editConfig.editable
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onCellClick", "data"])
        ]),
        (_ctx.editConfig.editable)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_vxe_button, {
                loading: _ctx.submiting,
                size: "medium",
                status: "primary",
                width: "200px",
                content: "暂存",
                onClick: _ctx.storeEvent
              }, null, 8, ["loading", "onClick"]),
              (_ctx.canSubmit)
                ? (_openBlock(), _createBlock(_component_vxe_button, {
                    key: 0,
                    loading: _ctx.submiting,
                    size: "medium",
                    status: "primary",
                    width: "200px",
                    content: "提交",
                    onClick: _ctx.submitEvent
                  }, null, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "fullscreen"]),
    _createVNode(_component_vxe_modal, {
      modelValue: _ctx.downData.editing,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.downData.editing = $event)),
      title: "下发配置",
      width: "1200",
      "min-height": "600",
      fullscreen: _ctx.fullScreen,
      "lock-scroll": "true",
      "show-zoom": "true",
      resize: "",
      "destroy-on-close": "true"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_vxe_toolbar, null, {
              buttons: _withId(() => [
                _createVNode(_component_vxe_input, {
                  modelValue: _ctx.downData.filterName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.downData.filterName = $event)),
                  placeholder: "卫生室名称关键字"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_vxe_button, { onClick: _ctx.searchEvent }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_table, {
              border: "",
              "row-config": {keyField:_ctx.id},
              "checkbox-config": { reserve: true },
              ref: "xTableVillage",
              data: _ctx.downData.villageList,
              onCheckboxAll: _ctx.selectAllChangeEvent,
              onCheckboxChange: _ctx.selectChangeEvent
            }, {
              default: _withId(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  width: "60"
                }),
                _createVNode(_component_vxe_column, {
                  field: "compName",
                  title: "卫生室名称"
                })
              ]),
              _: 1
            }, 8, ["row-config", "data", "onCheckboxAll", "onCheckboxChange"]),
            _createVNode(_component_vxe_pager, {
              background: "",
              "current-page": _ctx.downData.page.currentPage,
              "onUpdate:current-page": _cache[9] || (_cache[9] = ($event: any) => (_ctx.downData.page.currentPage = $event)),
              "page-size": _ctx.downData.page.pageSize,
              "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => (_ctx.downData.page.pageSize = $event)),
              onPageChange: _ctx.villagePageChange,
              total: _ctx.downData.page.totalResult,
              layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Total']
            }, null, 8, ["current-page", "page-size", "onPageChange", "total"])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_vxe_table, {
              border: "",
              ref: "xTableItem",
              data: _ctx.downData.itemList,
              onCheckboxAll: _ctx.selectAllItemChangeEvent,
              onCheckboxChange: _ctx.selectItemChangeEvent
            }, {
              default: _withId(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  width: "60"
                }),
                _createVNode(_component_vxe_column, {
                  field: "parentLabel",
                  width: "300",
                  title: "检查项"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemLabel",
                  title: "检查要点"
                })
              ]),
              _: 1
            }, 8, ["data", "onCheckboxAll", "onCheckboxChange"])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_vxe_button, {
            disabled: _ctx.downData.submitIng,
            size: "medium",
            status: "primary",
            width: "200px",
            content: "提交",
            onClick: _ctx.downSubmit
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "fullscreen"])
  ]))
})